import { render, staticRenderFns } from "./TabelaMinuta.vue?vue&type=template&id=ad4c5f26&scoped=true&"
import script from "./TabelaMinuta.vue?vue&type=script&lang=js&"
export * from "./TabelaMinuta.vue?vue&type=script&lang=js&"
import style0 from "./TabelaMinuta.vue?vue&type=style&index=0&id=ad4c5f26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad4c5f26",
  null
  
)

export default component.exports